//#region Imports
import React, { useEffect, useState } from "react";
import {
  StyleSheet,
  SafeAreaView,
  View,
  Platform,
  ScrollView,
  FlatList,
} from "react-native";
import { useTranslation } from "react-i18next";
import { useTheme } from "@react-navigation/native";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useAccountContext } from "../../hooks/useAccountContext";
import { useAssessment } from "../../hooks/useAssessment";
import CustomLabel from "../../components/CustomLabel/CustomLabel";
import CustomButton from "../../components/CustomButton/CustomButton";
import MyAssessments from "../SelfService/Assessments/MyAssessments";
import CreateGroup from "../SelfService/Assessments/CreateGroup";
import EditGroup from "../SelfService/Assessments/EditGroup";
import EditAssessment from "../SelfService/Assessments/EditAssessment";
import CreateAssessment from "../SelfService/Assessments/CreateAssessment";
import MyAssessmentsAdmin from "../SelfService/Assessments/MyAssessmentsAdmin.js";
import ResultsAssessment from "../SelfService/Assessments/ResultsAssessment";
import ResponseScreen from "../SelfService/Assessments/ResponseScreen";
import ParticipantsScreen from "../SelfService/Assessments/ParticipantsScreen";
import { generateUniqueID } from "../../components/SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions";
import RoleGuard from "../../components/RoleGuard";
import { TASKS, TASK_OPTIONS } from "../../constants/Tasks";
//#endregion

const HomePageAssessment = ({ route }) => {

  //#region Function Definition
  const { t } = useTranslation();
  const { user, clientApi, username } = useAuthContext();
  const {
    loadQuestionTypes,
    loadEveryAssessment,
    loadEveryAssessmentForUser,
    loadGroups,
    loadCompany,
    loadWorkflow,
    loadUserAssessments,
    loadAssessmentByUI,
    isLoading: assmLoading
  } = useAssessment();
  const { account } = useAccountContext();
  const { colors } = useTheme();
  const styles = makeStyles(colors);

  const [assmUi, setAssmUi] = useState("");
  const [wfl, setWfl] = useState("");
  const [showMyAssessments, setShowMyAssessments] = useState(0);
  const [showAssessmentsAdmin, setShowAssessmentsAdmin] = useState(0);
  const [showResponseScreen, setShowResponseScreen] = useState(0);
  const [showCreateScreen, setShowCreateScreen] = useState(0);
  const [showCreateGroup, setShowCreateGroup] = useState(0);
  const [showEditScreen, setShowEditScreen] = useState(0);
  const [showEditGroup, setShowEditGroup] = useState(0);
  const [showResultsScreen, setShowResultsScreen] = useState(0);
  const [showParticipationsScreen, setShowParticipationsScreen] = useState(0);
  const [responseAssessmentId, setResponseAssessmentId] = useState("");
  const [responseGroupId, setResponseGroupId] = useState("");
  const buttonTable = [1, 2, 3, 4, 5, 6, 7, 8];
  const [AssessmentList, setAssessmentList] = useState([]);
  const [userAssessmentList, setUserAssessmentList] = useState([]);
  const [GroupList, setGroupList] = useState([]);
  const [CompanyList, setCompanyList] = useState([]);
  const [workflowList, setWorkflowList] = useState([]);
  const [questionTypesList, setQuestionTypesList] = useState([]);
  const [employeesAvailable, setEmployeesAvailable] = useState([]);
  const [assessmentToLoad, setAssessmentToLoad] = useState({});
  const [response, setResponse] = useState(0);
  const [TaskOptions, setTaskOptions] = useState({});
  const [assmFromId, setAssmFromId] = useState({
    allowChangeOfAppraiser: false,
    appraisee: "",
    assmCompany: "",
    assmEmplUi: "",
    assmFromDate: "",
    assmGroupUi: "",
    assmSect: [],
    assmToDate: "",
    assmType: "",
    assmUi: "",
    description: "",
    employeeid: "",
    instructions: "",
    name: null,
    submitted: "",
    userid: null,
  });
  const [assm, setAssm] = useState({
    id: generateUniqueID(),
    assm_group_id: "",
    organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625",
    assm_title: "",
    assm_instructions: "",
    assm_from_date: "",
    assm_to_date: "",
    assm_allowChangeOfAppraiser: false,
    assm_type: "",
    assm_company: "",
    require_login: true,
  });

  // * Get groups request and assessments
  const groupChoices = [];
  let uniqueDescriptions = new Set();

  //#endregion

  //#region API Call
  const load = () => {
    loadCompany(clientApi, user.token, username)
      .then((respCompany) => {
        setCompanyList(respCompany);
        loadWorkflow(clientApi, user.token, username)
          .then((respWorkflow) => {
            setWorkflowList(respWorkflow);
          })
          .catch((innerError) => console.error(innerError));
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const loadAssessments = () => {
    loadEveryAssessment(clientApi, user.token, username)
      .then((respAssessment) => {
        setAssessmentList(respAssessment);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const loadAssessmentsByID = () => {
    loadAssessmentByUI(clientApi, user.token, username, assmUi)
      .then((respAssessmentByUi) => {
        setAssmFromId(respAssessmentByUi);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const loadAllGroups = () => {
    loadGroups(clientApi, user.token, username)
      .then((respGroups) => {
        setGroupList(respGroups);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const loadUserAssm = () => {
    if (account) {
      loadUserAssessments(clientApi, user.token, username, account.employeeId)
        .then((userData) => {
          setUserAssessmentList(userData);
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const load_questtypes = () => {
    loadQuestionTypes(clientApi, user.token, username)
      .then((respTypes) => {
        setQuestionTypesList(respTypes);
      })
      .catch((error) => {
        console.error(error);
      });
  };
  //#endregion

  //#region UseEffect
  useEffect(() => {
    load();
  }, []);

  useEffect(() => {
    loadAssessments();
  }, [showAssessmentsAdmin, showEditScreen]);

  useEffect(() => {
    loadAllGroups();
    if (showParticipationsScreen === 0 || showCreateScreen === 1) {
      setAssm({
        id: generateUniqueID(),
        assm_group_id: "",
        organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625",
        assm_title: "",
        assm_instructions: "",
        assm_from_date: "",
        assm_to_date: "",
        assm_allowChangeOfAppraiser: false,
        assm_type: "",
        assm_company: "",
        require_login: true,
      });
    }
  }, [showCreateScreen]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      try {
        localStorage.setItem('isRefresh', "true");
        localStorage.setItem('lastVisitedScreen', 'HomePageAssessment');
      } catch (error) {
        console.log(error.message);
      };
    };
    if (Platform.OS === 'web') {
      window.addEventListener('beforeunload', handleBeforeUnload);
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    };
  }, []);

  useEffect(() => {
    loadUserAssm();
  }, []);

  useEffect(() => {
    if (assmUi !== undefined && assmUi !== '') {
      loadAssessmentsByID();
    }
  }, [assmUi]);

  useEffect(() => {
    load_questtypes();
  }, []);

  GroupList.forEach((obj) => {
    if (!uniqueDescriptions.has(obj.description)) {
      groupChoices.push({ label: obj.description, value: obj.assmgroupUI });
      uniqueDescriptions.add(obj.description);
    }
  });

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      event.preventDefault();
      try {
        localStorage.setItem("isRefresh", "true");
        localStorage.setItem("lastVisitedScreen", "HomePageAssessment");
      } catch (error) {
        console.log(error.message);
      }
    };
    if (Platform.OS === "web") {
      window.addEventListener("beforeunload", handleBeforeUnload);
      return () => {
        window.removeEventListener("beforeunload", handleBeforeUnload);
      };
    }
  }, []);

  useEffect(() => {
    load();
    setShowMyAssessments(1);
  }, []);
  //#endregion

  return (
    <SafeAreaView style={[styles.main]}>
      {/* SubMenu */}
      <View>
        <FlatList
          horizontal
          showsHorizontalScrollIndicator={true}
          directionalLockEnabled={true}
          alwaysBounceVertical={false}
          data={buttonTable}
          contentContainerStyle={{
            alignSelf: "flex-start",
            marginBottom: "1%",
          }}
          showsVerticalScrollIndicator={false}
          renderItem={({ index }) => {
            return (
              <SafeAreaView>
                {index == 1 && Platform.OS === "web" && (
                  <RoleGuard parentTask={TASKS.ALLEMPLOYEETASKS} task={TASK_OPTIONS.ASSESSMENTS} requireCRUD>
                    <CustomButton
                      onPress={() => {
                        setShowAssessmentsAdmin(0);
                        setShowMyAssessments(1);
                        setShowResponseScreen(0);
                        setShowResultsScreen(0);
                        setShowCreateScreen(0);
                        setShowCreateGroup(0);
                        setShowEditScreen(0);
                        setShowParticipationsScreen(0);
                        setShowEditGroup(0);
                      }}
                      text={t("common:assessment")}
                      iconName="newspaper-outline"
                      show={showMyAssessments ? "HOME_SELECTED" : "HOME"}
                      type={showMyAssessments ? "HOME_SELECTED" : "HOME"}
                      textTop="0"
                      isGradient={showMyAssessments ? true : false}
                      sz={25}
                    />
                  </RoleGuard>
                )}

                {Platform.OS === 'web' &&
                  index == 2 && (
                    <RoleGuard parentTask={TASKS.ASSMMGMT} task={TASK_OPTIONS.ASSMMGMT} requireCRUD>
                      <CustomButton
                        onPress={() => {
                          setShowAssessmentsAdmin(1);
                          setShowMyAssessments(0);
                          setShowResponseScreen(0);
                          setShowResultsScreen(0);
                          setShowCreateScreen(0);
                          setShowParticipationsScreen(0);
                          setShowCreateGroup(0);
                          setShowEditScreen(0);
                          setShowEditGroup(0);
                        }}
                        text={t("common:assessmentsAdmin")}
                        iconName="clipboard-outline"
                        show={showAssessmentsAdmin ? "HOME_SELECTED" : "HOME"}
                        type={showAssessmentsAdmin ? "HOME_SELECTED" : "HOME"}
                        isGradient={showAssessmentsAdmin ? true : false}
                        textTop="0"
                        sz={25}
                      />
                    </RoleGuard>
                  )}
              </SafeAreaView>
            );
          }}
          keyExtractor={(item) => `${item}`}
        />
      </View>

      {/* My Assessments Screen */}
      {showMyAssessments ? (
        <SafeAreaView style={[styles.submain]}>
          <CustomLabel value={t("common:assessment")} type="MINORTITLE" />
          <MyAssessments
            data={userAssessmentList}
            isLoading={assmLoading}
            loadUserAssessments={loadUserAssm}
            setShowResponseScreen={setShowResponseScreen}
            setShowMyAssessments={setShowMyAssessments}
            setShowParticipationsScreen={setShowParticipationsScreen}
            setAssessmentToLoad={setAssessmentToLoad}
            setShowCreateGroup={setShowCreateGroup}
            setShowCreateScreen={setShowCreateScreen}
            setResponse={setResponse}
          />
        </SafeAreaView>
      ) : (
        <></>
      )}

      {/* // * Response Screen */}
      {showResponseScreen ? (
        <SafeAreaView style={styles.submain}>
          <CustomLabel
            value={t("common:assessmentResponse")}
            type="MINORTITLE"
          />
          <CustomLabel
            value={assessmentToLoad.cType + ' - ' +
              assessmentToLoad.assessment + ' - ' + (assessmentToLoad.submitted ?
                t("common:assessmentsubmited") : t("common:assessmentpending"))}
            type="MINORTITLE"
          />
          <View style={styles.line} />
          <ResponseScreen
            setShowMyAssessments={setShowMyAssessments}
            assmData={assessmentToLoad}
            setShowParticipationsScreen={setShowParticipationsScreen}
            setShowResponseScreen={setShowResponseScreen}
            setShowCreateScreen={setShowCreateScreen}
            setShowCreateGroup={setShowCreateGroup}
            setShowAssessmentsAdmin={setShowAssessmentsAdmin}
            assessmentToLoad={assessmentToLoad}
            response={response}
          />
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showResultsScreen ? (
        <SafeAreaView style={styles.submain}>
          <CustomLabel
            value={t("common:assessmentresult")}
            type="MINORTITLE"
          />
          <CustomButton
            iconName="close-outline"
            onPress={() => {
              setShowAssessmentsAdmin(1);
              setShowMyAssessments(0);
              setShowResponseScreen(0);
              setShowResultsScreen(0);
              setShowCreateScreen(0);
              setShowCreateGroup(0);
              setShowEditScreen(0);
              setShowParticipationsScreen(0);
              setShowEditGroup(0);
            }}
            show="HOME_BELL"
            type="HOME_BELL"
            textTop="2"
            sz={25}
          />
          <ResultsAssessment
            survId={responseAssessmentId}
            workflows={workflowList}
            wfl={wfl}
            assm={assm}
            assmUi={assmUi}
            setShowResponseScreen={setShowResponseScreen}
            setShowMyAssessments={setShowMyAssessments}
            setShowEditScreen={setShowEditScreen}
            setShowCreateGroup={setShowCreateGroup}
            setShowCreateScreen={setShowCreateScreen}
            setShowAssessmentsAdmin={setShowAssessmentsAdmin}
          />
        </SafeAreaView>
      ) : (
        <></>
      )}


      {Platform.OS === 'web' && showAssessmentsAdmin ? (
        <SafeAreaView style={[styles.submain]}>
          <CustomLabel value={t("common:assessmentsAdmin")} type="MINORTITLE" />
          <MyAssessmentsAdmin
            data={AssessmentList}
            assmUi={assmUi}
            setAssmUi={setAssmUi}
            setWfl={setWfl}
            groups={groupChoices}
            setShowCreateGroup={setShowCreateGroup}
            loadEveryAssessment={loadEveryAssessmentForUser}
            setShowMyAssessments={setShowMyAssessments}
            setResponseAssessmentId={setResponseAssessmentId}
            setResponseGroupId={setResponseGroupId}
            setShowParticipationsScreen={setShowParticipationsScreen}
            setShowResponseScreen={setShowResponseScreen}
            setShowAssessmentsAdmin={setShowAssessmentsAdmin}
            setShowCreateScreen={setShowCreateScreen}
            setShowEditScreen={setShowEditScreen}
            setShowEditGroup={setShowEditGroup}
            setShowResultsScreen={setShowResultsScreen}
          />
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showCreateGroup ? (
        <SafeAreaView style={styles.submain}>
          <CustomLabel value={t("common:groupcreate")} type="MINORTITLE" />
          <CreateGroup
            data={AssessmentList}
            setShowResponseScreen={setShowResponseScreen}
            setShowCreateGroup={setShowCreateGroup}
            setShowEditGroup={setShowEditGroup}
            setShowMyAssessments={setShowMyAssessments}
            setShowEditScreen={setShowEditScreen}
            setShowCreateScreen={setShowCreateScreen}
            setShowAssessmentsAdmin={setShowAssessmentsAdmin}
          />
        </SafeAreaView>
      ) : (
        <></>
      )}

      {/* //* Edit Group Screen */}
      {showEditGroup ? (
        <SafeAreaView style={styles.submain}>
          <CustomLabel value={t("common:groupedit")} type="MINORTITLE" />
          <EditGroup
            groupId={responseGroupId}
            setShowResponseScreen={setShowResponseScreen}
            setShowMyAssessments={setShowMyAssessments}
            setShowCreateGroup={setShowCreateGroup}
            setShowEditScreen={setShowEditScreen}
            setShowEditGroup={setShowEditGroup}
            setShowCreateScreen={setShowCreateScreen}
            setShowAssessmentsAdmin={setShowAssessmentsAdmin}
          />
        </SafeAreaView>
      ) : (
        <></>
      )}

      {/* //* Create Assessment Screen */}
      {showCreateScreen ? (
        <SafeAreaView style={styles.submain}>
          <CustomLabel value={t("common:assessmentcreate")} type="MINORTITLE" />
          <CreateAssessment
            data={[groupChoices, CompanyList, workflowList, questionTypesList]}
            setGroupList={setGroupList}
            assm={assm}
            setWfl={setWfl}
            setAssm={setAssm}
            setAssmUi={setAssmUi}
            assmUi={assmUi}
            setShowResponseScreen={setShowResponseScreen}
            setShowEditScreen={setShowEditScreen}
            setShowEditGroup={setShowEditGroup}
            setShowCreateGroup={setShowCreateGroup}
            setShowCreateScreen={setShowCreateScreen}
            setShowParticipationsScreen={setShowParticipationsScreen}
            setShowMyAssessments={setShowMyAssessments}
            setShowAssessmentsAdmin={setShowAssessmentsAdmin}
          />
        </SafeAreaView>
      ) : (
        <></>
      )}

      {/* //* Edit Assessment Screen */}
      {showEditScreen ? (
        <SafeAreaView style={styles.submain}>
          <CustomLabel value={t("common:assessmentedit")} type="MINORTITLE" />
          <EditAssessment
            data={[groupChoices, CompanyList, workflowList, questionTypesList]}
            setGroupList={setGroupList}
            setAssmUi={setAssmUi}
            setWfl={setWfl}
            assmUi={assmUi}
            prevAssm={assmFromId}
            setShowResponseScreen={setShowResponseScreen}
            setShowEditScreen={setShowEditScreen}
            setShowEditGroup={setShowEditGroup}
            setShowCreateGroup={setShowCreateGroup}
            setShowCreateScreen={setShowCreateScreen}
            setShowParticipationsScreen={setShowParticipationsScreen}
            setShowMyAssessments={setShowMyAssessments}
            setShowAssessmentsAdmin={setShowAssessmentsAdmin}
          />
        </SafeAreaView>
      ) : (
        <></>
      )}

      {showParticipationsScreen ? (
        <ScrollView>
          <SafeAreaView style={styles.submain}>
            <CustomLabel value={t("common:participations")} type="MINORTITLE" />
            <ParticipantsScreen
              workflows={workflowList}
              employees={employeesAvailable}
              wfl={wfl}
              assm={assm}
              assmUi={assmUi}
              setAssmUi={setAssmUi}
              setShowParticipationsScreen={setShowParticipationsScreen}
              setShowResponseScreen={setShowResponseScreen}
              setShowEditScreen={setShowEditScreen}
              setShowResultsScreen={setShowResultsScreen}
              setShowEditGroup={setShowEditGroup}
              setShowCreateGroup={setShowCreateGroup}
              setShowCreateScreen={setShowCreateScreen}
              setShowMyAssessments={setShowMyAssessments}
              setShowAssessmentsAdmin={setShowAssessmentsAdmin}
            />
          </SafeAreaView>
        </ScrollView>
      ) : (
        <></>
      )}
    </SafeAreaView>
  );
};

const makeStyles = (colors, width) =>
  StyleSheet.create({
    main: {
      flex: 1,
      marginTop: "1%",
      marginHorizontal: 10
    },
    submain: {
      flex: 1,
      backgroundColor: colors.background,
    },
    scrollMain: {
      backgroundColor: "transparent",
    },
    item: {

    },
    row: {
      flex: 1,
      flexDirection: "row",
    },
    line: {
      borderBottomColor: colors.buttons_primary,
      borderBottomWidth: StyleSheet.hairlineWidth,
      margin: 20,
    },
  });

export default HomePageAssessment;
